import { render, staticRenderFns } from "./tabsSecciones.vue?vue&type=template&id=e5f134ac&scoped=true"
import script from "./tabsSecciones.vue?vue&type=script&lang=js"
export * from "./tabsSecciones.vue?vue&type=script&lang=js"
import style0 from "./tabsSecciones.vue?vue&type=style&index=0&id=e5f134ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f134ac",
  null
  
)

export default component.exports